import React from "react";

interface PropsLine {
    linesVertical: any[];
    t: any;
}

export default function LinesVertical({linesVertical, t}: PropsLine) {
    const circleStyle = {
        fill: '#3a6379',
    };

    const renderLine = (line: any, index: number) => {
        let person1X, person1Y, person2X, person2Y;

        if (line.relationship === t('father') || line.relationship === t('mother')) {
            person1X = (line.person1.x + (line.person1.width / 2));
            person1Y = (line.person1.y);
            person2X = (line.person2.x + (line.person2.width / 2));
            person2Y = (line.person2.y + line.person2.height);
        } else if (line.relationship === t('son') || line.relationship === t('daughter')) {
            person1X = (line.person1.x + (line.person1.width / 2));
            person1Y = (line.person1.y + (line.person1.height));
            person2X = (line.person2.x + (line.person2.width / 2));
            person2Y = (line.person2.y);
        }

        // Calcular puntos de control para la curva de Bézier
        const controlPointX1 = person1X + (person2X - person1X) / 3;
        const controlPointY1 = person1Y;
        const controlPointX2 = person2X - (person2X - person1X) / 3;
        const controlPointY2 = person2Y;

        return (
            <g key={index}>
                <path
                    d={`M${person1X},${person1Y} C${controlPointX1},${controlPointY1} ${controlPointX2},${controlPointY2} ${person2X},${person2Y}`}
                    fill="none"
                    stroke="#3a6379"
                    strokeWidth="1"
                />
                <circle
                    cx={person1X}
                    cy={person1Y}
                    r={3} // Tamaño del círculo
                    style={circleStyle}
                />
                <circle
                    cx={person2X}
                    cy={person2Y}
                    r={3} // Tamaño del círculo
                    style={circleStyle}
                />
            </g>
        );
    }

    return (
        <>
            {linesVertical && linesVertical.length > 0 && linesVertical.map((line, index) => {
                return <svg key={index}
                            style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}>
                    {renderLine(line, index)}
                </svg>
            })}
        </>
    )
}
